import { render } from "./ListItem.vue?vue&type=template&id=1ce2d8cd&bindings={\"program\":\"props\",\"questionsConfig\":\"options\",\"showSponsoringTable\":\"options\",\"getSlug\":\"options\",\"formatMoney\":\"options\"}"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"
script.render = render

export default script